import axios from "axios";
import { toast } from "sonner";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

export const normalizeBeats = (rows) =>
  rows.map((r) => ({ ...r, id: r.id || r._id }));

export const openDownloads = () => window.dispatchEvent(new Event("open-downloads"));

export const startCheckout = async (lookupKey, beat) => {
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key: lookupKey,
      quantity: 1,
      origin_url: window.location.origin,
      beat_id: beat?.id || "",
      beat_title: beat?.title || "",
    });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
      return;
    }
    throw new Error("no checkout url");
  } catch (e) {
    toast.error("Checkout isn't available right now — give it a minute and try again.");
  }
};
